// extracted by mini-css-extract-plugin
export default {"input":"V2QMAT9q6dFSgcULWz0v","flagButton":"Zy2zKx7yR9r420c_URwR","countryList":"T726AsJZiOiaFsmUhaem"};